export const fireGoogleAnalyticsEvent = (event, eventData) => {
  if (typeof window?.gtag === "function") {
    window?.gtag("event", event, {
      ...eventData,
    });
  }
};
